/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */
 import { SUB_PATH } from '../../public/config.json';

let pathExtension = '';
if (SUB_PATH && SUB_PATH !== 'PRODUCTION'.concat('_SUB_PATH')) {
  pathExtension = `${SUB_PATH}`;
}

export const PORT: string = `${window.location.protocol === 'https:' ? '443' : '9017'}`;
export const BASE_URL: string = `ws${window.location.protocol === 'https:' ? 's' : ''}://${window.location.hostname}`;
export const PATH_EXTENSION = `${pathExtension}${window.location.protocol === 'https:' ? '/logengine' : ''}`;
